<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true"  
            [DateInit]="direccion?.desde" 
            [DateEnd]="direccion?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="direccionesHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="direccion?.id">
</iboxtools>

<app-direcciones-list *ngIf="!verDetalle && !buscando" [personalId]="personalId"  
                                                       [direcciones]="direcciones" 
                                                       [permisoEdicion]="permisoEdicion"
                                                       [fechaslist]="fechaslist"
                                                       [personal]="personal"
                                                       (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-direcciones-list>

<app-direccion-detalle *ngIf="verDetalle" #ChildDireccionDetalle [direccion]="direccion" 
                                                                 [enabledForm]="habilitarFormDetalle" 
                                                                 [MensajeError]="MensajeError" 
                                                                 [desdeAnterior]="desdeAnterior" 
                                                                 [ingreso]="ingreso">
</app-direccion-detalle>

